import { fetchAuthDetails } from './actions/auth-action.helpers.js';

const getAuthToken = async ()=>{
    const authDetails = await fetchAuthDetails();
    if (authDetails.isLoggedIn) {
        return `Bearer ${authDetails.accessToken}`;
    }
};
/**
 * getIsLoggedInAsync
 *
 * We need this function to get the fresh logged in state from cognito APIs itself.
 * This will make sure that we are not using the stale auth state from the store and session is always refreshed.
 * Use this as a priority over useAuth hook.
 *
 * @returns {boolean} isLoggedIn
 */ const getIsLoggedInAsync = async ()=>{
    try {
        const authDetails = await fetchAuthDetails();
        return authDetails.isLoggedIn;
    } catch (error) {
        throw error;
    }
};

export { getAuthToken, getIsLoggedInAsync };
//# sourceMappingURL=auth.helpers.js.map
